export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["د"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شراء"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مقابل"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نشط"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رابط الإعلان"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرّف الصانع"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الوصف"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المهلة"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تاريخ الإنشاء"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سأدفع"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سأتسلم"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حد التداول"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الكل"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الصفقات"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرّف العرض"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السعر"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختيار الحساب"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خارج الحد"])}
}